import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../Shared/Sidebar';
import Icon from '../Shared/Icons';
import { PROGRAMS } from '../../config/programs';
import { fetchMembers, fetchReports } from '../../utils/programData';
import { ensureMsaadaMembers } from '../../utils/autoSync';
import { isoWeekKey, weekLabel, daysLeftInWeek } from '../../utils/weekUtils';
import AnnouncementsWidget from '../Shared/AnnouncementsWidget';
import { S, T } from './ui';

export default function ProgramHub() {
  const navigate = useNavigate();
  const [stats, setStats] = useState({});
  const [loading, setLoading] = useState(true);
  const wk = isoWeekKey();

  useEffect(() => { load(); }, []);

  async function load() {
    try {
      await ensureMsaadaMembers();
      const out = {};
      for (const p of PROGRAMS) {
        const members = await fetchMembers(p.id);
        const reports = await fetchReports({ programId: p.id, kind: 'individual', weekKey: wk });
        out[p.id] = {
          members: members.length,
          done: reports.length,
          pending: Math.max(0, members.length - reports.length),
        };
      }
      setStats(out);
    } catch (err) { console.error(err); }
    setLoading(false);
  }

  return (
    <div style={S.layout}>
      <Sidebar />
      <div style={S.main}>

        <div style={{ marginBottom: '18px' }}>
          <h1 style={S.h1}>Programu Zetu</h1>
          <p style={{ ...S.sub, marginTop: '6px' }}>
            Kila programu ina eneo lake — wanachama, ripoti na data
            hazichanganyiki. Wiki ya sasa: <strong>{weekLabel()}</strong>
            {' '}({daysLeftInWeek()} siku zimebaki)
          </p>
        </div>

        <AnnouncementsWidget limitTo={4} />

        {PROGRAMS.map(p => {
          const st = stats[p.id] || {};
          return (
            <div
              key={p.id}
              onClick={() => navigate(`/programs/${p.id}`)}
              style={{
                ...S.card, cursor: 'pointer', padding: 0, overflow: 'hidden',
                borderLeft: `4px solid ${p.color}`,
              }}
            >
              <div style={{ padding: '18px 20px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <div style={{
                    width: '44px', height: '44px', borderRadius: '13px',
                    background: `${p.color}15`, display: 'flex',
                    alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                  }}>
                    <Icon name={p.icon} size={21} color={p.color} />
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontFamily: T.serif, fontSize: '17px', color: T.green }}>{p.name}</div>
                    <div style={{ fontSize: '12px', color: T.muted, marginTop: '3px' }}>{p.tagline}</div>
                  </div>
                  <span style={{ color: T.muted, fontSize: '18px' }}>›</span>
                </div>

                {!loading && (
                  <div style={{ display: 'flex', gap: '9px', marginTop: '15px', flexWrap: 'wrap' }}>
                    <Stat value={st.members ?? 0} label="Wanachama" color={p.color} />
                    <Stat value={st.done ?? 0} label="Ripoti wiki hii" color="#059669" />
                    <Stat value={st.pending ?? 0} label="Bado" color={st.pending ? '#D97706' : T.muted} />
                  </div>
                )}
              </div>
            </div>
          );
        })}

        <div
          onClick={() => navigate('/programs/insights')}
          style={{ ...S.card, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '12px' }}
        >
          <div style={{
            width: '40px', height: '40px', borderRadius: '12px', background: '#00695C15',
            display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
          }}>
            <Icon name="chart" size={19} color="#00695C" />
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: '14.5px', fontWeight: 700, color: T.ink }}>Chess & Lifeskills — Programu Zote</div>
            <div style={{ fontSize: '12px', color: T.muted, marginTop: '2px' }}>
              Linganisha programu zote na uone mbinu hii inatusaidiaje
            </div>
          </div>
          <span style={{ color: T.muted, fontSize: '18px' }}>›</span>
        </div>

        <div
          onClick={() => navigate('/staff/weekly')}
          style={{ ...S.card, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '12px' }}
        >
          <div style={{
            width: '40px', height: '40px', borderRadius: '12px', background: '#4527A015',
            display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
          }}>
            <Icon name="user" size={19} color="#4527A0" />
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: '14.5px', fontWeight: 700, color: T.ink }}>Ripoti Yangu ya Wiki</div>
            <div style={{ fontSize: '12px', color: T.muted, marginTop: '2px' }}>
              Changamoto, mafanikio, observations na mipango ya wiki ijayo
            </div>
          </div>
          <span style={{ color: T.muted, fontSize: '18px' }}>›</span>
        </div>

      </div>
    </div>
  );
}

function Stat({ value, label, color }) {
  return (
    <div style={{
      background: `${color}0F`, borderRadius: '10px', padding: '8px 13px', minWidth: '78px',
    }}>
      <div style={{ fontSize: '19px', fontWeight: 800, color, lineHeight: 1 }}>{value}</div>
      <div style={{ fontSize: '10.5px', color: T.muted, marginTop: '3px' }}>{label}</div>
    </div>
  );
}
